/* eslint-disable jsx-a11y/alt-text */

import { Rule } from "@with-nx/simple-ui/atoms";
import { ReusableSection } from "@with-nx/simple-ui/atoms";
import { FeaturesContainer } from "@with-nx/simple-ui/organisms";
import { FiPenTool, FiRepeat, FiThumbsUp, FiTool } from "react-icons/fi";

export const ReusableScenicProjectionsFeatures = () => {
  return (
    <ReusableSection>
      <div className="container">
        <Rule parse="!hl d:block mb:36" tag="h4">
          Scenic Projections Features
        </Rule>
        <FeaturesContainer
          items={[
            {
              title: "Easy Load-in",
              description:
                "Imagine not having to hang costly painted backdrop rentals. Simply hang your projector, plug in your Mac or PC, and you’re ready to use digital scenery.",
              icon: (
                <FiThumbsUp
                  style={{ stroke: "url(#blue-gradient)" }}
                  size={24}
                  title="thumbs up icon"
                />
              ),
            },
            {
              title: "Pre-Cued Packages",
              description:
                "All videos and images in our packages are pre-programmed in the easy-to-use projections control software, StagePlayer. ",
              icon: (
                <FiPenTool
                  style={{ stroke: "url(#blue-gradient)" }}
                  size={24}
                  title="pen icon"
                />
              ),
            },
            {
              title: "Stage Magic",
              description:
                "World-class animation means magic moments and special effects. Imagine your Elsa conjuring her ice palace or Mary Poppins flying over London.",
              icon: (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <title>stage magic icon</title>
                  <path
                    d="M2.81663 11.9999C6.86625 10.1241 10.1217 6.86929 11.9983 2.82013C13.8708 6.86898 17.1304 10.1227 21.1796 11.9984C17.1309 13.8709 13.8772 17.1305 12.0016 21.1796C10.1285 17.1296 6.86744 13.8752 2.81663 11.9999Z"
                    stroke="url(#paint0_linear_1_50)"
                    strokeWidth="2"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_1_50"
                      x1="0.539299"
                      y1="0.0693767"
                      x2="26.4864"
                      y2="0.0693765"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#46C2F2" />
                      <stop offset="1" stopColor="#1875FF" />
                    </linearGradient>
                  </defs>
                </svg>
              ),
            },
            {
              title: "No Fly Space Needed",
              description:
                "Projections solve many spatial issues, including no fly space. ",
              icon: (
                <FiTool
                  style={{ stroke: "url(#blue-gradient)" }}
                  size={24}
                  title="tool icon"
                />
              ),
            },
            {
              title: "Cinematic Motion",
              description:
                "All packages come with scene transitions, weather and special effects.",
              icon: (
                <img
                  loading="lazy"
                  width="24"
                  height="24"
                  src="/assets/icons/film.svg"
                  alt="film icon"
                />
              ),
            },
            {
              title: "Reduce Runtime",
              description:
                "No need for blackouts and physical set changes with digital scenery.",
              icon: (
                <FiRepeat
                  style={{ stroke: "url(#blue-gradient)" }}
                  size={24}
                  title="repeat icon"
                />
              ),
            },
          ]}
          xl={8}
          lg={8}
          md={12}
        />
      </div>
    </ReusableSection>
  );
};
